import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AutoLogout from '../autologout';
import { clearAuthStorage, markLogoutSignal } from '../authservice/session';

function Topnavbar({ toggleSidebar }) {

    AutoLogout();
    const navigate = useNavigate();
    const [staffName, setStaffName] = useState('');

    const logoutUser = (e) => {
        e.preventDefault();
        clearAuthStorage();
        markLogoutSignal();
        navigate('/');
    };

    // useEffect(() => {
    //     const name = localStorage.getItem('username');
    //     if (name) {
    //         setStaffName(name);
    //     }
    // }, []);

    useEffect(() => {
        const name = localStorage.getItem('username');
        if (name) {
            const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
            setStaffName(capitalizedName);
        }
    }, []);

    return (
        <div className="header">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12 d-flex justify-content-between align-items-center">


                        <div className="nav-control">
                            <div className="hamburger" onClick={toggleSidebar}>
                                <span className="line" />
                                <span className="line" />
                                <span className="line" />
                            </div>
                        </div>


                        <ul className="topbar-nav nav align-items-center">
                            <li className="nav-item topbar-welcome">
                                <span className="welcome-text">
                                    🧑‍🤝‍🧑 Welcome, {staffName}
                                </span>
                            </li>
                            <li className="nav-item">
                                <button type="button" onClick={logoutUser} className="nav-link logout-link">
                                    <i className="ti-power-off" /> <span>Logout</span>
                                </button>
                            </li>
                        </ul>


                    </div>

                </div>
            </div>

        </div>

    );
}

export default Topnavbar;